import React, { useEffect, useState } from "react";
import { Form, Input, Button, DatePicker, Select, Row, Col, Card, Tag } from "antd";
import { getTicketEnquiry, EditTicketEnquiry, getServiceCentersList, getAllInternalUsers } from "../../../services/apiService";
const { Option } = Select;

const TicketEnquiry = ({ record }) => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [data1, setData1] = useState([])
    const [iscompleted, setisCompleted] = useState(false)
  const [users, setUsers] = useState([]);

    if (!record) return <div>No record selected</div>;

    const [form] = Form.useForm();
    useEffect(() => {
        fetchServices()
        fetchServiceCenters()
        fetchUsers()
    }, []);

     const fetchUsers = async () => {
        try {
          const data = await getAllInternalUsers();
          setUsers(data.Data || []);
        } catch (error) {
          console.error("Failed to fetch users:", error);
        } finally {
          setLoading(false);
        }
      };
    const fetchServices = async () => {
        try {
            setLoading(true);
            const res = await getTicketEnquiry({ id: record.id });
            setData(res.data || []);
            const completed = res.data.find(
                (e) => e.status?.toLowerCase() === "closed"
            );

            setisCompleted(!!completed);
            console.log("sercen", res.data);
        } catch (error) {
            console.error("Warranty list error:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchServiceCenters = async () => {
        try {
            setLoading(true);
            const res = await getServiceCentersList();
            setData1(res.data || []);
            console.log("sercen", res.data);
        } catch (error) {
            console.error("Warranty list error:", error);
        } finally {
            setLoading(false);
        }
    };
    const EditServices = async (values) => {
        try {
            setLoading(true);
            const res = await EditTicketEnquiry({
                enquiryid: record.id,
                discription: values.description,
                date: new Date().toISOString(),
                status: values.status,
                priority: values.priority,
                shifted: values.shifted
            });
            fetchServices()
        } catch (error) {
            console.error("Warranty list error:", error);
        } finally {
            setLoading(false);
        }
    };

    const onFinish = (values) => {
        console.log("Form Values:", values);
        EditServices(values)
    };
    return (
        <div style={{ padding: "20px" }}>
            <Card
                title={`Ticket ID: ${record.ticketid}`}
                style={{ marginBottom: 20, backgroundColor: '#E6F2FF' }}
                variant="outlined"   // ✅ replaces bordered

            >
                <Row gutter={[16, 6]}>
                    <Col span={6}>
                        <strong>Customer:</strong> {record.customername}
                    </Col>

                    <Col span={6}>
                        <strong>Customer Mobile:</strong> {record.mobilenumber}
                    </Col>

                    <Col span={6}>
                        <strong>Service Type:</strong> {record.servicetype}
                    </Col>

                    <Col span={6}>
                        <strong>City:</strong> {record.city}
                    </Col>

                    <Col span={6}>
                        <strong>State:</strong> {record.state}
                    </Col>

                    <Col span={6}>
                        <strong>Service Person:</strong> {record.first_name}
                    </Col>
                     <Col span={6}>
                        <strong>Service Mobile:</strong> {record.mobile}
                    </Col>

                    <Col span={6}>
                        <strong>Status:</strong>{" "}
                        <Tag>{record.status}</Tag>
                    </Col>

                    <Col span={6}>
                        <strong>Date:</strong>{" "}
                        {new Date(record.date).toLocaleDateString("en-GB")}
                    </Col>
                    <Col span={6}>
                        <strong>Description:</strong>{record.discription}
                    </Col>
                </Row>
            </Card>

            {!iscompleted && <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                style={{ maxWidth: 800, margin: "auto" }}
            >
                <Row gutter={16}>
                    {/* Enquiry ID */}
                    {/* <Col span={12}>
                        <Form.Item
                            label="Enquiry ID"
                            name="enquiryid"
                            rules={[{ required: true, message: "Please enter enquiry ID" }]}
                        >
                            <Input type="number" placeholder="Enter enquiry ID" />
                        </Form.Item>
                    </Col> */}

                    {/* Description */}
                    <Col span={12}>
                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[{ required: true, message: "Please enter description" }]}
                        >
                            <Input placeholder="Enter description" />
                        </Form.Item>
                    </Col>

                    {/* Date */}
                    {/* <Col span={12}>
                        <Form.Item
                            label="Date"
                            name="date"
                            rules={[{ required: true, message: "Please select date" }]}
                        >
                            <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Col> */}

                    {/* Status */}
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: "Please select status" }]}
                        >
                            <Select placeholder="Select status">
                                <Option value="in_progress">In Progress</Option>
                                <Option value="closed">Closed</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    {/* Priority */}
                    <Col span={12}>
                        <Form.Item
                            label="Priority"
                            name="priority"
                            rules={[{ required: true, message: "Please select priority" }]}
                        >
                            <Select placeholder="Select priority">
                                <Option value="low">Low</Option>
                                <Option value="medium">Medium</Option>
                                <Option value="high">High</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    {/* Shifted */}
                    <Col span={12}>
                        <Form.Item
                            label="Shifting to"
                            name="shifted"
                            // rules={[{ message: "Select service person" }]}
                        >
                            <Select
                                placeholder={
                                    record.servicetype == "Person to shift"
                                }
                            >
                                {record.servicetype == 'Purchase'
                                    ? users
                                        .filter((p) => p.usertype === "Marketing Manager")
                                        .map((p) => (
                                            <Option key={p.id} value={p.id}>
                                                {p.username}
                                            </Option>
                                        ))
                                    : data1.map((p) => (
                                        <Option key={p.id} value={p.id}>
                                            {p.username}
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                {/* Submit Button (Full Width) */}
                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                </Form.Item>
            </Form>}
            <div>
                {data.map((user) => (
                    <Card
                        key={user.id}
                        title={user.first_name}
                        variant="outlined"
                        style={{ marginBottom: 16 }}
                    >
                        <Row gutter={[16, 6]}>
                            {/* <Col span={8}>
                                <strong>Email:</strong> {user.email}
                            </Col> */}
                            <Col span={6}>
                                <strong>Priority:</strong> {user.priority}
                            </Col>
                            <Col span={6}>
                                <strong>Status:</strong> {user.status}
                            </Col>
                            <Col span={6}>
                                <strong>Description:</strong> {user.discription}
                            </Col>
                           
                             <Col span={6}>
                                <strong>Date:</strong> {new Date(user.date).toLocaleDateString("en-GB")}
                            </Col>
                            {user.shifted && <Col span={6}>
                                <strong>Shifted To:</strong> {user.first_name}
                            </Col>}
                        </Row>
                    </Card>
                ))}
            </div></div>
    );
};

export default TicketEnquiry;
